<template>
  <div
    ref="modal"
    class="modal fade"
    tabindex="-1"
    aria-labelledby="staticBackdropLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-xl">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="staticBackdropLabel">
            {{ $t("videos.videos") }}
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            :aria-label="$t(`orderChange.close`)"
          ></button>
        </div>
        <div class="modal-body">
          <div v-if="!uploadWindow">
            <div class="row">
              <draggable
                class="dragArea row custom-input pt-2"
                tag="div"
                :list="videos"
                :group="{ name: 'g1' }"
                item-key="id"
                v-bind="dragOptions"
                :forceFallback="true"
                :scroll="true"
                :scrollSensitivity="100"
                v-on:end="moveEvent"
              >
                <template #item="{ element }">
                  <div class="col-2 my-2 img-uploader-thumbnail">
                    <img
                      v-if="!element.remote"
                      class="img-thumbnail"
                      :src="mediaUrl + '/' + element.path + '/frame1.jpg'"
                      :alt="element.name"
                    />
                    <div
                      v-else
                      class="
                        img-thumbnail
                        d-flex
                        align-items-center
                        justify-content-center
                      "
                      style="height: 100px; background: #f8f9fa"
                    >
                      <BaseIcon name="play-circle" size="32" />
                      <span class="ms-1">GD</span>
                    </div>
                    <div class="img-btns">
                      <button
                        class="btn btn-outline-primary"
                        v-on:click="deleteVideo(element)"
                      >
                        <BaseIcon name="trash" />
                      </button>
                    </div>
                    <div
                      class="small text-truncate mt-1 text-center"
                      :title="element.name"
                    >
                      {{ element.name }}
                    </div>
                  </div>
                </template>
                <template #footer>
                  <div class="col-2 my-2">
                    <button
                      class="
                        img-thumbnail
                        d-flex
                        align-items-center
                        justify-content-center
                        w-100
                      "
                      style="height: 100px"
                      v-on:click="uploadWindow = true"
                    >
                      <BaseIcon name="plus-circle" size="32" />
                    </button>
                  </div>
                </template>
              </draggable>
            </div>
          </div>
          <div v-else>
            <div class="row">
              <div class="col-3 text-start">
                <button
                  class="btn w-100 d-block mb-2"
                  v-on:click="uploadMenu = 'upload'"
                  :class="{
                    'btn-primary': uploadMenu === 'upload',
                    'btn-simple': uploadMenu !== 'upload',
                  }"
                >
                  {{ $t("videos.uploadFile") }}
                </button>
                <button
                  class="btn w-100 d-block mb-2"
                  v-on:click="uploadMenu = 'google'"
                  :class="{
                    'btn-primary': uploadMenu === 'google',
                    'btn-simple': uploadMenu !== 'google',
                  }"
                >
                  {{ $t("videos.googleDrive") }}
                </button>
                <button
                  class="btn w-100 d-block"
                  v-on:click="uploadMenu = 'gallery'"
                  :class="{
                    'btn-primary': uploadMenu === 'gallery',
                    'btn-simple': uploadMenu !== 'gallery',
                  }"
                >
                  {{ $t("videos.browseGallery") }}
                </button>
              </div>
              <div class="col" v-if="uploadMenu === 'upload'">
                <file-pond
                  name="video"
                  ref="pond"
                  label-idle="Drop files here..."
                  v-bind:allow-multiple="true"
                  accepted-file-types="video/mp4, video/avi, video/ogg, video/webm, video/quicktime, video/x-quicktime, video/x-msvideo"
                  v-bind:files="myFiles"
                  v-on:init="handleFilePondInit"
                  :server="server"
                  :chunkUploads="true"
                  :chunkForce="true"
                  :chunkSize="1000000"
                  :credits="false"
                />
              </div>
              <div class="col" v-else-if="uploadMenu === 'google'">
                <div class="card">
                  <div class="card-body text-center">
                    <h6 class="mb-4">{{ $t("videos.googleDrive") }}</h6>
                    <drive-picker
                      v-if="googleClientId && googleApiKey"
                      :client-id="googleClientId"
                      :app-id="googleApiKey"
                      ref="googlePicker"
                      mime-types="video/mp4, video/avi, video/ogg, video/webm, video/quicktime, video/x-quicktime, video/x-msvideo"
                      parent=""
                      :select-folder-enabled="false"
                      :include-folders="true"
                    >
                    </drive-picker>
                    <template v-else>
                      <div class="alert alert-warning">
                        Google Drive integration is not configured.
                        <div class="mt-2">
                          <small
                            >Missing VUE_APP_GOOGLE_CLIENT_ID or
                            VUE_APP_GOOGLE_PICKER_API_KEY</small
                          >
                        </div>
                      </div>
                      <div class="mb-3 text-start">
                        <label class="form-label">Video ID (Manual)</label>
                        <input
                          v-model="googleDriveVideoId"
                          type="text"
                          class="form-control"
                          placeholder="Enter Google Drive File ID"
                        />
                      </div>
                      <div class="mb-3 text-start">
                        <label class="form-label">Video Name</label>
                        <input
                          v-model="googleDriveVideoName"
                          type="text"
                          class="form-control"
                          placeholder="Enter Video Name"
                        />
                      </div>
                      <button
                        class="btn btn-primary w-100"
                        @click="saveGoogleDriveVideo"
                        :disabled="!googleDriveVideoId"
                      >
                        Save Manual ID
                      </button>
                    </template>
                  </div>
                </div>
              </div>
              <div class="col" v-else>
                <div class="row">
                  <div
                    class="col-3 my-2 img-uploader-thumbnail"
                    v-for="video in selectable"
                    :key="video.id"
                    v-on:click="addVideoToOperation(video)"
                  >
                    <img
                      v-if="!video.remote"
                      class="img-thumbnail"
                      :src="mediaUrl + '/' + video.path + '/frame1.jpg'"
                      :alt="video.name"
                    />
                    <div
                      v-else
                      class="
                        img-thumbnail
                        d-flex
                        align-items-center
                        justify-content-center
                      "
                      style="height: 100px; background: #f8f9fa"
                    >
                      <BaseIcon name="play-circle" size="32" />
                      <span class="ms-1">GD</span>
                    </div>
                    <div
                      class="small text-truncate mt-1 text-center"
                      :title="video.name"
                    >
                      {{ video.name }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="text-end mt-4">
              <button class="btn btn-primary" v-on:click="uploadWindow = false">
                {{ $t("videos.back") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
import vueFilePond from "vue-filepond";
import "filepond/dist/filepond.min.css";

import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import http from "../../modules/http";
import tenant from "../../modules/tenant";
const BaseIcon = defineAsyncComponent(() => import("../icons/BaseIcon.vue"));
const bootstrap = require("bootstrap");
import draggable from "vuedraggable";
import "@googleworkspace/drive-picker-element";

// Create component
const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview
);

export default {
  name: "ManufacturingOperationVideosModal",
  props: {
    show: Boolean,
    productId: Number,
    operationId: Number,
  },
  computed: {
    mediaUrl() {
      return tenant.getAppVideoUrl();
    },
    googleClientId() {
      return process.env.VUE_APP_GOOGLE_CLIENT_ID;
    },
    googleApiKey() {
      return process.env.VUE_APP_GOOGLE_PICKER_API_KEY;
    },
  },
  data: function () {
    return {
      uploadWindow: false,
      uploadMenu: "upload",
      myFiles: [],
      videos: [],
      selectable: [],
      googleDriveVideoId: "",
      googleDriveVideoName: "",
      dragOptions: {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
      },
      server: {
        process: this.upload,
        revert:
          process.env.VUE_APP_MEDIA_API +
          "/" +
          tenant.getTenantName() +
          "/videos/revert",
        restore:
          process.env.VUE_APP_MEDIA_API +
          "/" +
          tenant.getTenantName() +
          "/videos/restore",
        load:
          process.env.VUE_APP_MEDIA_API +
          "/" +
          tenant.getTenantName() +
          "/videos/load",
        fetch:
          process.env.VUE_APP_MEDIA_API +
          "/" +
          tenant.getTenantName() +
          "/videos/upload/a",
      },
    };
  },
  watch: {
    uploadMenu() {
      if (this.uploadMenu === "google") {
        const _this = this;
        setTimeout(function () {
          _this.$refs.googlePicker.addEventListener(
            "picker-picked",
            _this.onDrivePicked
          );
        }, 100);
      }
    },
    show() {
      let myModal = bootstrap.Modal.getInstance(this.$refs.modal);
      if (!myModal) {
        myModal = new bootstrap.Modal(this.$refs.modal, {
          backdrop: "static",
        });
      }

      if (this.show) {
        myModal.show();
        this.loadVideos();
      } else {
        myModal.hide();
      }
    },
  },
  methods: {
    loadVideos() {
      http
        .fetch(
          "/files/manufacturing-operation-videos?operation=" + this.operationId
        )
        .then((data) => {
          this.videos = data;
        });

      http
        .fetch("/files/product-videos?product=" + this.productId)
        .then((data) => {
          this.selectable = data.images[0]?.images || [];
        });
    },
    deleteVideo(video) {
      if (!confirm("Are you sure you want to delete this video association?"))
        return;

      http
        .fetch("/manufacturing-operations/delete-video", {
          operation: this.operationId,
          video: video.id,
        })
        .then(() => {
          let e = this.videos.indexOf(video);
          if (e > -1) {
            this.videos.splice(e, 1);
          }
        });
    },
    addVideoToOperation(video) {
      http
        .fetch(`/products/manufacturing-operations/add-video`, {
          operation: this.operationId,
          video: video.id,
        })
        .then(() => {
          this.videos.push(video);
          this.uploadWindow = false;
        });
    },
    saveGoogleDriveVideo() {
      http
        .fetch("/files/google-drive-video", {
          video_id: this.googleDriveVideoId,
          name: this.googleDriveVideoName,
          operation: this.operationId,
        })
        .then((data) => {
          this.videos.push(data.video);
          this.googleDriveVideoId = "";
          this.googleDriveVideoName = "";
          this.uploadWindow = false;
        });
    },
    moveEvent() {
      http.fetch(`/manufacturing-operations/move-videos`, {
        operation: this.operationId,
        videos: this.videos.map((e) => e.id),
      });
    },
    upload(
      fieldName,
      file,
      metadata,
      load,
      error,
      progress,
      abort,
      transfer,
      options
    ) {
      const _this = this;
      const request = new XMLHttpRequest();

      let send = {
        type: "manufacturing_operation",
        id: _this.productId,
        operation: _this.operationId,
        videos: [file.name],
      };

      http.fetch("/files/upload", send).then((data) => {
        const formData = new FormData();
        formData.append("token", data.token);
        formData.append("album", data.album);
        formData.append("category", "operation");

        request.open(
          "POST",
          process.env.VUE_APP_MEDIA_API +
            "/" +
            tenant.getTenantName() +
            "/videos/upload"
        );

        request.setRequestHeader("Upload-Length", file.size);
        request.setRequestHeader("Upload-Name", encodeURIComponent(file.name));

        request.upload.onprogress = (e) => {
          progress(e.lengthComputable, e.loaded, file.size);
        };

        request.onload = function () {
          if (request.status >= 200 && request.status < 300) {
            transfer(request.responseText);

            _this.chunkUpload(
              0,
              file,
              options,
              fieldName,
              data,
              progress,
              error,
              load,
              request.responseText
            );
          } else {
            error("oh no");
          }
        };

        request.send(formData);
      });

      return {
        abort: () => {
          request.abort();
          abort();
        },
      };
    },
    chunkUpload(
      start,
      file,
      options,
      fieldName,
      data,
      progress,
      error,
      load,
      fileId,
      i = 0
    ) {
      let _this = this;
      if (start < file.size) {
        let chunkEnd = Math.min(start + options.chunkSize, file.size);
        let chunkSize = chunkEnd - start;
        const chunk = file.slice(start, chunkEnd);

        const chunkForm = new FormData();
        chunkForm.append(fieldName, chunk, file.name);
        chunkForm.append("token", data.token);
        chunkForm.append("album", data.album);
        chunkForm.append("category", "operation");
        chunkForm.append("_method", "PATCH");

        const request = new XMLHttpRequest();

        request.open(
          "POST",
          process.env.VUE_APP_MEDIA_API +
            "/" +
            tenant.getTenantName() +
            "/videos/upload/" +
            fileId
        );

        request.setRequestHeader("Upload-Offset", start);
        request.setRequestHeader("Upload-Length", chunkSize);
        request.setRequestHeader("Upload-Name", encodeURIComponent(file.name));

        request.upload.onprogress = (e) => {
          progress(e.lengthComputable, start + e.loaded, file.size);
        };

        request.onload = function () {
          if (request.status >= 200 && request.status < 300) {
            _this.chunkUpload(
              chunkEnd,
              file,
              options,
              fieldName,
              data,
              progress,
              error,
              load,
              fileId
            );

            if (request.responseText?.length > 30) {
              let data2 = JSON.parse(request.responseText);
              _this.videos.push(data2.operation.videos[0]);
              _this.addVideoToOperation(data2.operation.videos[0]);
            }
          } else {
            if (i >= options.chunkRetryDelays.length) {
              error("oh no");
            } else {
              setTimeout(() => {
                _this.chunkUpload(
                  start,
                  file,
                  options,
                  fieldName,
                  data,
                  progress,
                  error,
                  load,
                  fileId,
                  i + 1
                );
              }, options.chunkRetryDelays[i]);
            }
          }
        };

        request.send(chunkForm);
      } else {
        load();
      }
    },
    handleFilePondInit: function () {
      console.log("FilePond has initialized");
    },
    onDrivePicked(e) {
      console.log(e);
      const files = e.detail.docs;
      if (files && files.length > 0) {
        this.googleDriveVideoId = files[0].id;
        this.googleDriveVideoName = files[0].name;
        this.saveGoogleDriveVideo();
      }
    },
  },
  components: { BaseIcon, FilePond, draggable },
};
</script>
